import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getBooking(payload?: {
  page?: number;
  limit?: number;
  search?: string;
  userId?: string;
  organizationId?: string;
}) {
  try {
    const page = payload?.page ?? 0;
    const limit = payload?.limit ?? 25;
    const search = payload?.search ?? "";
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search,
    });
    if (payload?.organizationId) {
      qs.set("organizationId", payload.organizationId);
    }
    const response = await makeCall(
      `${urls.GETCUSTOMER}?${qs.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getCustomerById(id: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETCUSTOMER}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateCustomer(id: string, body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(`${urls.UPDATECUSTOMER}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getCustomerActivity(customerId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETCUSTOMERACTIVITY}${customerId}?page=1&limit=50`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
